/* Delegated listeners also cover Shopify editor section re-renders. */
(() => {
  if (window.jinmangNavHoverLoaded) return;
  window.jinmangNavHoverLoaded = true;
  const desktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const selector = '.header__inline-menu header-menu > details';
  const timers = new Map();
  const findMenu = (target) => {
    if (!(target instanceof Element)) return null;
    return target.closest(selector) || target.closest('.header__inline-menu .jm-header-menu--split')?.querySelector(':scope > details');
  };
  const interactionRoot = (menu) => menu.closest('header-menu.jm-header-menu--split') || menu;
  const clear = (menu) => { clearTimeout(timers.get(menu)); timers.delete(menu); };
  const close = (menu) => {
    clear(menu);
    menu.open = false;
    menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
  };
  const open = (menu) => {
    document.querySelectorAll(selector).forEach(other => { if (other !== menu) close(other); });
    clear(menu);
    menu.open = true;
    menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
  };
  document.addEventListener('pointerover', (event) => {
    if (!desktop.matches || event.pointerType === 'touch') return;
    const menu = findMenu(event.target);
    if (menu) open(menu);
    else if (event.target instanceof Element && event.target.closest('.header__inline-menu > ul > li')) {
      document.querySelectorAll(selector).forEach(close);
    }
  });
  document.addEventListener('pointerout', (event) => {
    if (!desktop.matches) return;
    const menu = findMenu(event.target);
    if (!menu) return;
    const root = interactionRoot(menu);
    if (event.relatedTarget instanceof Node && root.contains(event.relatedTarget)) return;
    clear(menu);
    timers.set(menu, setTimeout(() => {
      timers.delete(menu);
      const focus = document.activeElement;
      if (!root.matches(':hover') && !(root.contains(focus) && focus !== menu.querySelector(':scope > summary'))) close(menu);
    }, 250));
  });
  document.addEventListener('toggle', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches(selector)) return;
    const menu = event.target;
    menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(menu.open));
    if (menu.open) document.querySelectorAll(selector).forEach(other => { if (other !== menu) close(other); });
  }, true);
  document.addEventListener('keydown', (event) => {
    const menu = findMenu(event.target);
    if (!menu) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close(menu);
      menu.querySelector(':scope > summary')?.focus();
    } else if (event.key === 'ArrowDown' && event.target === menu.querySelector(':scope > summary')) {
      event.preventDefault();
      open(menu);
      menu.querySelector('a[href]')?.focus();
    }
  });
  document.addEventListener('pointerdown', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('.header__inline-menu')) {
      document.querySelectorAll(selector).forEach(close);
    }
  });
  desktop.addEventListener('change', () => document.querySelectorAll(selector).forEach(close));
})();
